import "./footer.css";

const Footer = () => {
  return (
    <>
      <footer>
        <div className="text-center">
          ©{new Date().getFullYear()} savoirstudio. All Rights Reserved
        </div>
      </footer>
    </>
  );
};

export default Footer;
